export enum MassiveServiceFlags {
  /** Load the table of request */
  LOAD_SERVICES_TABLE,
  /** This flag is controlled by the button */
  CREATE_SERVICES,
  /** Activates the progress modal */
  ROUTING_PACKAGES,
  /** Enable the button to close the progress modal when something fail */
  ROUTING_FAIL,
}
